import { useEffect, useState } from 'react';
import { Flags } from 'react-feature-flags';
import { Unit } from '../../common/constants';
import { LabeledNumberInput } from '../../components/LabeledNumberInput/LabeledNumberInput';
import { useAppDispatch, useAppSelector } from '../../configuration/setup/hooks';
import { selectStateOfCharge } from '../../store/charging/chargingSelectors';
import { updateStateOfCharge } from '../../store/charging/chargingSlice';

export const SoCOptions = () => {
    const dispatch = useAppDispatch();

    const stateOfCharge = useAppSelector(selectStateOfCharge);

    const [initSoC, setInitSoC] = useState<number>(stateOfCharge.initSoC);
    const [destinationSoC, setDestinationSoC] = useState<number>(stateOfCharge.destinationSoC);
    const [minSoC, setMinSoC] = useState<number>(stateOfCharge.minSoC);
    const [maxSoC, setMaxSoC] = useState<number>(stateOfCharge.maxSoC);

    useEffect(() => {
        dispatch(
            updateStateOfCharge({
                initSoC,
                minSoC,
                maxSoC,
                destinationSoC,
            })
        );
    }, [initSoC, minSoC, maxSoC, destinationSoC]);

    return (
        <>
            <div className='display-flex align-items-end gap-10' data-testid='init-soc'>
                <LabeledNumberInput
                    className='flex-1-1-0 margin-0'
                    labelId='intl-msg:smartRoute.vehicle.initSoC'
                    value={initSoC}
                    unit={Unit.pct}
                    integerOnly
                    hasError
                    onChange={(value: number) => setInitSoC(value)}
                />
            </div>
            <div className='display-flex align-items-end gap-10' data-testid='destination-soc'>
                <LabeledNumberInput
                    className='flex-1-1-0 margin-0'
                    labelId='intl-msg:smartRoute.vehicle.SoCODestination'
                    value={destinationSoC}
                    unit={Unit.pct}
                    integerOnly
                    hasError
                    onChange={(value: number) => setDestinationSoC(value)}
                />
            </div>

            <Flags authorizedFlags={['chargingOptions']}>
                <div className='display-flex align-items-end gap-10' data-testid='min-max-soc'>
                    <LabeledNumberInput
                        className='flex-1-1-0'
                        labelId='intl-msg:smartRoute.vehicle.minSoC'
                        value={minSoC}
                        unit={Unit.pct}
                        integerOnly
                        hasError
                        onChange={(value: number) => setMinSoC(value)}
                    />
                    <LabeledNumberInput
                        className='flex-1-1-0'
                        labelId='intl-msg:smartRoute.vehicle.maxSoC'
                        value={maxSoC}
                        unit={Unit.pct}
                        integerOnly
                        onChange={(value: number) => setMaxSoC(value)}
                    />
                </div>
            </Flags>
        </>
    );
};
